import CitySEOHead from "@/components/feature/CitySEOHead";
import type { CityConfig } from "../types";

export default function CitySEO({ config }: { config: CityConfig }) {
  return (
    <CitySEOHead
      city={config.city}
      state={config.state}
      stateAbbr={config.stateAbbr}
      route={config.route}
      title={config.title}
      description={config.metaDescription}
      geoPlacename={config.geoPlacename}
      geoPosition={config.geoPosition}
      faqs={config.faqs}
      servicesSchema={config.servicesSchema}
      statePageName={config.statePageName}
      statePageRoute={config.statePageRoute}
      lastModified={config.lastModified}
      keywords={config.keywords}
      ogImage={config.heroImageUrl}
      areaServedList={config.areaServedList}
      serviceAreaDesc={config.serviceAreaDesc}
      hasPhysicalOffice={(config as any).hasPhysicalOffice}
    />
  );
}